import { useEffect } from 'react';
import { Map } from 'ol';
import { LayerItem } from './types'; // Adjust the import path based on your project structure

export const useMaxZoomOnLayers = (map: Map, layers: LayerItem[]) => {
  useEffect(() => {
    const view = map.getView();

    const updateLayerVisibility = () => {
      const zoom = view.getZoom();
      if (zoom === undefined) {
        return;
      }

      layers.forEach((layerItem) => {
        const { layer, properties } = layerItem;

        // Exit early if maxZoom is not defined
        if (!properties?.maxZoom) {
          return;
        }

        // The layer isn't active so do not update visibility
        if (!layerItem.isVisible) {
          return;
        }

        const isVisible = zoom > properties.maxZoom;
        layer.setVisible(isVisible);
      });
    };

    updateLayerVisibility();
    view.on('change:resolution', updateLayerVisibility);

    return () => {
      view.un('change:resolution', updateLayerVisibility);
    };
  }, [map, layers]);
};
